<template>
  <section>
    <h4 class="cropper-header">
      {{$t('CP.cropAThumbnail')}}
    </h4>
    <div class="cropper">
      <img
        ref="cropperImage"
        :src="src"
        alt=""
        class="image"
      />
    </div>
    <div v-if="error" class="invalid-message m-2">
      <span>
        {{ $t('CP.errorPictureCropUrlSize') }}
      </span>
    </div>
<!--    <img-->
<!--      class="destination"-->
<!--      :src="destination"/>-->
    <div class="form-buttons">
      <button-app
        class="form-button form-button_cancel"
        @clicked="cancelSubmit"
        color-scheme="gray"
        type="button">
        {{ $t('CP.cancel') }}
      </button-app>
      <button-app
        class="form-button form-button_save"
        color-scheme="blue"
        @clicked="handleSubmit"
        type="button"
      >
        {{ $t('CP.create') }}
      </button-app>
    </div>
  </section>
</template>

<script>
import Cropper from 'cropperjs';
import { SET_CROPPER_INFO } from '@/store/operations/types';
import { FETCH_EVENTS_REQUEST } from '@/store/events/types';
import ButtonApp from '../../components/Button/ButtonApp';

export default {
  name: 'AppCropper',
  components: { ButtonApp },
  props: {
    src: {
      type: String,
      default: '',
    },
    dispatchAction: {
      type: String,
      default: '',
    },
    dispatchData: {
      type: Object,
      default: (() => {}),
    },
    reloadEvents: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      cropper: {},
      destination: '',
      cropperImage: {},
      error: false,
    };
  },
  methods: {
    cancelSubmit() {
      this.$store.commit(SET_CROPPER_INFO, {});
      this.$bvModal.hide('cropper');
    },
    async handleSubmit() {
      this.destination = this.cropper.getCroppedCanvas().toDataURL();
      if (this.destination.length > 1000000) {
        this.error = true;
        return;
      }
      this.error = false;
      if (this.dispatchAction) {
        const { dispatchData = {} } = this;
        // eslint-disable-next-line prefer-destructuring
        dispatchData.data.image_url = this.destination.split(',')[1];
        await this.$store.dispatch(this.dispatchAction, dispatchData);
      } else {
        this.$store.commit(SET_CROPPER_INFO, {
          destination: this.destination,
        });
      }
      if (this.reloadEvents) this.$store.dispatch(FETCH_EVENTS_REQUEST);
      this.$bvModal.hide('cropper');
    },
  },
  mounted() {
    this.cropperImage = this.$refs.cropperImage;
    this.cropper = new Cropper(this.cropperImage, {
      zoomable: false,
      scalable: false,
      minCropBoxWidth: 70,
      aspectRatio: 1,
      viewMode: 1,
    });
  },
};
</script>

<style scoped>
  .cropper-header {
    color: var(--text-main-color);
    text-align: center;
    margin-bottom: 32px;
  }
  .cropper {
    width: 50%;
    height: 50vh;
    margin: auto;
  }
  .image {
    /*filter: brightness(50%);*/
    display: block;
  }
  .destination {
    max-width: 90%;
    max-height: 50vh;
    margin: 20px auto;
  }
  .form-buttons {
    display: flex;
    flex: 1 0 50%;
    justify-content: flex-end;
    margin: 22px 0 0 0;
  }
  .form-button {
    width: 160px;
    height: 38px;
    margin: 0;
  }
  .form-button_cancel {
    margin: 0 8px 0 0;
  }
</style>
